import { Component, OnInit, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { tConsultHeadModelWithPatientInfo } from 'src/app/models/tConsultHeadModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { isNullOrUndefined } from 'util';
import { tConsultCertModel, tConsultCertModelPrint } from 'src/app/models/tConsultCertModel';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tOnConsultService } from 'src/app/services/tOnConsult.service';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { GenderModel } from 'src/app/models/SimpleConfigModel';

import { MatTableDataSource, ShowOnDirtyErrorStateMatcher } from '@angular/material';
import { DatePipe } from '@angular/common';
import { AppSettings } from 'src/app/shared/AppSettings';
import { SimpleConfigService } from 'src/app/services/SimpleConfig.service';
import { Gender } from 'src/app/models/non-master-model/Gender';

import { tShopService } from 'src/app/services/tShop.service';
import { tPatientService } from 'src/app/services/tPatient.service';
import { CrypService } from 'src/app/services/Non-Master/Cryp.service';
@Component({
  selector: 'app-sick-leave-cert',
  templateUrl: './sick-leave-cert.component.html',
  styleUrls: ['./sick-leave-cert.component.css']
})
export class SickLeaveCertComponent implements OnInit {

   @ViewChild('autoClick') autoClick: ElementRef;
 // picFullPath = './assets/img/print/doc_logo.png';
 // picFullPath_SignShop2 = './assets/img/print/signShop2.png';

  urlStartingPath = AppSettings.shopAdapter.imagePath;
  signShop2Path = this.urlStartingPath+"/assets/img/print/signShop2.png";
  picFullPath = this.urlStartingPath+"/assets/img/print/doc_logo.png";

  // picFullPath = window.location.origin + '/assets/img/print/doc_logo.png';

  isHiddenShop2Sign = false;
  isHiddenDefaultSign = false;

  TAG = 'SickLeaveCertComponent';

  isHiddenShop1Info = true;
  isHiddenShop2Info = true;


  showEng = false;
  shopAddressEng1='';
  shopAddressEng2='';
  shopAddressEng3='';
  shopAddress1='';
  shopAddress2='';
  shopAddress3='';
  shopPhone='';
  shopEmail='';
  shopNameTC = ''; //shop chinese name

  ecName = '';
  HKIDStr='';
  @Input() action: string;
  @Input() status: string;
  @Input() tableKeyValue: string;
  @Input() msg: string;
  @Input() searchFilter: number;
  @Input() docType: number;
  @Input() genderList: GenderModel[];
  displayGender;

  onConsultDataList: tConsultHeadModelWithPatientInfo;

  patientTitle_selection;
  patientGender_selection;

  printCertList: tConsultCertModelPrint;


  patientGender_selection_Display = '';




  constructor(
    private router: Router,
    public activeModal: NgbActiveModal,
    private tOnConsultService: tOnConsultService,
    private dateTimeConvertService: DateTimeConvertService,
    private tEmployeeService: tEmployeeService,
    public datepipe: DatePipe,
    private SimpleConfigService:SimpleConfigService,
    private tShopService: tShopService,
    private tPatientService: tPatientService,
    private CrypService: CrypService,
    ) { }

  ngOnInit() {


    this.printCertList = new tConsultCertModelPrint();

    this.setDefaultLanguageString(AppComponent.usingLanguage);
    this.onConsultDataList = JSON.parse(localStorage.getItem('onConsultModel'));
    this.ecName = this.onConsultDataList.clthTherapistName;
    this.getOnConsultInfo();

    this.getShopInfo(NavigationComponent.selectedShopID.toString());

    if (NavigationComponent.selectedShopID.toString() === '2') {
      this.isHiddenShop2Sign = false;
      this.isHiddenDefaultSign = true;
    } else {
      this.isHiddenShop2Sign = true;
      this.isHiddenDefaultSign = false;
    }


    if (NavigationComponent.selectedShopID.toString() === '2') {
      this.isHiddenShop1Info = true;
      this.isHiddenShop2Info = false;
    } else {
      this.isHiddenShop1Info = false;
      this.isHiddenShop2Info = true;
    }

    //console.table(this.onConsultDataList);
    //console.table(this.printCertList);

  }
  ngAfterViewInit() {
     let inputElement: HTMLElement = this.autoClick.nativeElement as HTMLElement;
     setTimeout(() => {
      //  inputElement.click();
     }, 600);
  }
  getOnConsultInfo() {
    // tslint:disable-next-line:max-line-length
    this.tOnConsultService.getOnConsultInfo(this.onConsultDataList.shopID, this.onConsultDataList.clthConsultNumber).subscribe(data => {

      this.onConsultDataList = data[0];

      for(var i = 0 ; i < this.genderList.length ; i++){

        if(this.onConsultDataList.patientGender == this.genderList[i].id){

        if(this.onConsultDataList.patientGender==1){
          this.displayGender="She"
        }else{
          this.displayGender="He"
        }
          if(this.showEng == false){
            this.patientGender_selection_Display = this.genderList[i].chineseName +' '+ this.genderList[i].engName;

          }else{
            this.patientGender_selection_Display = this.genderList[i].engName;

          }
        }

      }

      this.loadPatientData();
      this.getSavedConsultCert();
    });

  }

  getSavedConsultCert() {
    this.tOnConsultService.getSavedConsultCert(NavigationComponent.selectedShopID.toString(),
      this.onConsultDataList.clthConsultNumber, this.onConsultDataList.patientID).subscribe((data: any) => {

        if (!isNullOrUndefined(data[0])) {
          // this.log.d(this.TAG, 'getSavedConsultCert: ' + JSON.stringify(data[0]));
          this.printCertList = data[0];

          const dbStartDate =  this.datepipe.transform(this.dateTimeConvertService.ConvertCurrentDBDay(new Date(data[0]['startDate'].toString())),"dd-MM-yyyy");
          const dbEndDate = this.datepipe.transform(this.dateTimeConvertService.ConvertCurrentDBDay(new Date(data[0]['endDate'].toString())),"dd-MM-yyyy");

          const dbArrDate = this.dateTimeConvertService.ConvertCurrentDBDay(
            new Date(this.onConsultDataList.clthArrivalDateTime.toString()));


          this.printCertList.startDatePrint = dbStartDate;
          this.printCertList.endDatePrint = dbEndDate;
          this.printCertList.ArrivalDatePrint = dbArrDate;
          this.printCertList.printDate=this.datepipe.transform(this.dateTimeConvertService.ConvertCurrentDBDay(new Date(data[0]['prescriptionPrintDate'].toString())),"dd-MM-yyyy");



          if (!isNullOrUndefined(this.printCertList.therapistID)) {
            this.tEmployeeService.getDataById(
              1, // NavigationComponent.selectedShopID,
              this.printCertList.therapistID.toString()).subscribe(therapisdata => {

                this.printCertList.therapistName = therapisdata.employeeSurname;
                this.printCertList.regNo1 = therapisdata.drCMP;
                this.printCertList.regNo2 = therapisdata.drRegNo;
                this.printCertList.doctorRemark=therapisdata.employeeRemark3;
                if (this.printCertList.regNo2 !== '006712') {
                  this.isHiddenShop2Sign = true;
                }

            });

          }
          //console.table(this.printCertList);
        }

      });
  }


  setDefaultLanguageString(language: String){
    switch(language) {
      case SystemDefaultModel.Language_Chinese:

        this.showEng = false;
        break;
      case SystemDefaultModel.Language_English:

        this.showEng = true;

        break;
      default:

        this.showEng = false;

        break;
    }
  }

  cancel() {
    // this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }

  isShowAPM(text: any) {

    if (isNullOrUndefined(text))
    {
      return false;
    }


    return true;

  }



  changeFont(className:string, operator:string){

    console.log("doing changeFont operator = "+operator);
    let element: any;
  //  let element2: any;

      element = document.getElementById(className);

      var style = window.getComputedStyle(element, null).getPropertyValue('font-size');
      var fontSize = parseFloat(style);

      if(operator === '+'){
        element.style.fontSize = (fontSize + 1) + 'px';

      }else{
        element.style.fontSize = (fontSize - 1) + 'px';

      }

  }


  loadPatientData() {
    this.tPatientService.getDataById(NavigationComponent.selectedShopID.toString(), this.onConsultDataList.patientID).subscribe(data => {



      const patientIHKID = data.patientIHKID.toString();
      var decrypted = this.CrypService.decryptStr(patientIHKID).toString();
      this.HKIDStr=decrypted.substring(0,5);

    });
  }

  getShopInfo(shopID: string) {
    this.tShopService.getDataById(shopID).subscribe(
      (res: any) => {
        console.log(res);
        this.shopAddressEng1=res.shopAddressEng1;
        this.shopAddressEng2=res.shopAddressEng2;
        this.shopAddressEng3=res.shopAddressEng3;
        this.shopPhone=res.shopPhone;
        this.shopAddress1=res.shopAddress1;
        this.shopAddress2=res.shopAddress2;
        this.shopAddress3=res.shopAddress3;
        this.shopEmail=res.shopEmail;
        this.shopNameTC = res.shopName;
       // this.shopFax=res.shopFax;
        // this.shopList = res;
        // this.shopName = this.shopList[0].shopName.toString();
        // console.log('shopList = ' + JSON.stringify(res));
        // console.log('shopList = ' + this.shopList[0].shopName.toString());
      },
      err => {
        console.log(err);
      },
    );
  }

  getPatientName(){
    var nameString='';
    if(this.onConsultDataList.patientChiName!=null || this.onConsultDataList.patientChiName!=''){
      nameString+=this.onConsultDataList.patientChiName+' '
    }
    if(this.onConsultDataList.patientSurname){
      nameString+=this.onConsultDataList.patientSurname+' '
    }

    if(this.onConsultDataList.patientChiName==this.onConsultDataList.patientSurname){
      nameString=this.onConsultDataList.patientChiName;
    }


    return nameString;
  }

  getFormatDate(value:String){
    if (!value) return "";
    // const str_date =  value.split('-').join('/');
    return value;
  }

}
